import { render, staticRenderFns } from "./EventMenu.vue?vue&type=template&id=0ff73609&scoped=true&"
import script from "./EventMenu.vue?vue&type=script&lang=js&"
export * from "./EventMenu.vue?vue&type=script&lang=js&"
import style0 from "./EventMenu.vue?vue&type=style&index=0&id=0ff73609&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff73609",
  null
  
)

export default component.exports